<template>
  <div class="our-features">
    <div class="our-features__wrap" v-if="data.active === 'Y'">
      <div
        :class="`our-features__cell our-features__cell--${index} ${item.is_big ? 'our-features__cell--big' : ''}`"
        v-for="(item, index) in items"
        :key="index"
      >
        <a
          :href="item.link || 'javascript:void(0)'"
          class="our-features__item"
          :class="{ 'our-features__item--big': item.is_big, 'our-features__item--link-disable' : !item.link }"
        >
          <span class="our-features__item-img-wrap">
            <img
              loading="lazy"
              data-force-load="true"
              :src="isMobile ? item.image_mob : item.image"
              :alt="item.title"
            >
          </span>
          <span class="our-features__item-title-wrap">
            <span class="our-features__item-title">{{ item.title }}</span>
            <span class="our-features__item-subtitle" v-if="item.subtitle">{{ item.subtitle }}</span>
          </span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { isTouch } from '@/mixins/isTouchDevice'

export default {
  name: 'OurFeaturesBlock',
  data () {
    return {
      windowWidth: window.innerWidth
    }
  },
  mixins: [isTouch],
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters(['isUkLanguage']),
    title () {
      return this.data[`title_${this.isUkLanguage ? 'uk' : 'ru'}`]
    },
    items () {
      return this.data?.data
    },
    isMobile () {
      return this.windowWidth < 768
    }
  },
  mounted () {
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth
    })
  }
}
</script>

<style scoped lang="sass">
.our-features
  padding: 52px 15px 42px
  +mmax($large)
    padding: 30px 15px 20px
  &__wrap
    display: grid
    grid-template-columns: 2fr 1fr 1fr
    grid-auto-rows: 288px
    margin: 0 -14px
    +mmax($large)
      grid-auto-rows: 220px
      margin: 0 -7px
    +mmax($mid)
      grid-template-columns: 1fr 1fr 1fr 1fr
      grid-auto-rows: 165px
    +mmax($small)
      grid-template-columns: 1fr 1fr
      grid-auto-rows: 165px
  &__cell
    display: flex
    padding: 14px
    +mmax($large)
      padding: 7px
    &--big
      grid-column: 1
      grid-row: 1/3
      +mmax($mid)
        grid-column: 1/5
        grid-row: 1/3
      +mmax($small)
        grid-column: 1/3
        grid-row: 1/3
      .our-features__item-title-wrap
        margin: auto
    &--1
      grid-column: 2
      grid-row: 1
      +mmax($mid)
        grid-column: 1
        grid-row: 3
      +mmax($small)
        grid-column: 1
        grid-row: 3
    &--2
      grid-column: 3
      grid-row: 1
      +mmax($mid)
        grid-column: 2
        grid-row: 3
      +mmax($small)
        grid-column: 2
        grid-row: 3
    &--3
      grid-column: 2
      grid-row: 2
      +mmax($mid)
        grid-column: 3
        grid-row: 3
      +mmax($small)
        grid-column: 1
        grid-row: 4
    &--4
      grid-column: 3
      grid-row: 2
      +mmax($mid)
        grid-column: 4
        grid-row: 3
      +mmax($small)
        grid-column: 2
        grid-row: 4
  &__item
    border-radius: 5px
    background: #F5F5F5
    display: flex
    flex-direction: column
    align-items: center
    flex-grow: 1
    padding: 12px
    img
      max-height: 100%
    &-img-wrap
      margin-bottom: 28px
      height: 64%
      display: flex
      flex-direction: column
      justify-content: center
      align-items: center
      +mmax($tablet--hor)
        height: 60%
      +mbetween($mid, $large)
        margin-bottom: 20px
      +mmax($mid)
        margin-bottom: 12px
    &-title
      color: #2E2E2E
      text-align: center
      font-size: 18px
      font-weight: 500
      +mmax($mid)
        font-size: 14px
      &-wrap
        text-align: center
        display: flex
        flex-direction: column
        align-items: center
        +mmax($tablet--hor)
          line-height: 0.9
    &-subtitle
      color: #2E2E2E
      text-align: center
      font-size: 24px
      font-weight: 400
      +mmax($tablet--hor)
        font-size: 16px
      +mmax($small)
        font-size: 14px
        margin-bottom: 13px
    &--link-disable
      pointer-events: none
    &--big
      +mbetween($small, $mid)
        flex-direction: row
      .out-features__title-wrap
        margin-top: auto
        display: flex
        flex-direction: column
        +mbetween($small, $mid)
          order: 2
          margin-bottom: auto
          width: 40%
          padding-left: 25px
      .our-features__item-title
        font-size: 36px
        margin-bottom: 20px
        order: 1
        +mbetween($small, $mid)
          text-align: left
        +mmax($mid)
          font-size: 24px
          margin-bottom: 11px
      .our-features__item-subtitle
        order: 2
        +mbetween($small, $mid)
          text-align: left
      .our-features__item-img-wrap
        height: 72%
        order: 3
        margin: 0 -12px -12px
        width: calc(100% + 24px)
        justify-content: flex-end
        +mbetween($small, $mid)
          width: 70%
          height: calc(100% + 12px)
        img
          width: 100%
          +mmax($mid)
            width: auto
            margin-left: auto
</style>
